import { ChevronRight } from '@carbon/icons-react'
import styles from './HowItWorksSection.module.scss'
import { Upload, MachineLearning, Download } from '@carbon/icons-react'

export function HowItWorksSection() {
  const steps = [
    {
      icon: Upload,
      color: 'blue',
      title: 'Téléversez',
      text: 'PDF, DOC, TXT ou MD',
    },
    {
      icon: MachineLearning,
      color: 'green',
      title: "L'IA analyse",
      text: 'Extraction et génération',
    },
    {
      icon: Download,
      color: 'purple',
      title: 'Récupérez',
      text: 'Téléchargez ou partagez',
    },
  ]

  return (
    <div className={styles.timeline}>
      {steps.map(({ icon: Icon, color, title, text }, index) => (
        <div key={title} className={styles.step}>
          <div className={styles.stepContent}>
            <div
              className={`${styles.stepIcon} ${styles[`stepIcon${color.charAt(0).toUpperCase() + color.slice(1)}`]}`}
            >
              <Icon size={20} />
            </div>
            <div className={styles.stepText}>
              <span className={styles.stepTitle}>{title}</span>
              <span className={styles.stepDesc}>{text}</span>
            </div>
          </div>
          {index < steps.length - 1 && (
            <ChevronRight size={20} className={styles.arrow} aria-hidden />
          )}
        </div>
      ))}
    </div>
  )
}
